import { put, takeEvery, call } from '@redux-saga/core/effects';
import {
  get_meals,
  get_meals_error,
  get_meals_success,
  create_meal,
  create_meal_error,
  create_meal_success,
  get_single_meal,
  get_single_meal_success,
  get_single_meal_error,
  delete_meal,
  delete_meal_success,
  delete_meal_error,
  update_meal,
  update_meal_error,
  update_meal_success,
  get_export,
  get_export_error,
  get_export_success,
  get_weekly_preference,
  get_weekly_preference_error,
  get_weekly_preference_success,
  get_ingredients,
  get_ingredients_success,
  get_ingredients_error,
  create_ingredients,
  create_ingredients_error,
  create_ingredients_success,
  get_ingredient_list,
  get_ingredient_list_error,
  get_ingredient_list_success,
  update_ingredient,
  update_ingredient_error,
  update_ingredient_success,
  delete_ingredient,
  delete_ingredient_error,
  delete_ingredient_success,
  get_ingredient_export_list,
  get_ingredient_export_list_error,
  get_ingredient_export_list_success,
  get_preview_weekly_preference,
  get_preview_weekly_preference_success,
  get_preview_weekly_preference_error,
  get_tag_preferences,
  get_tag_preferences_error,
  get_tag_preferences_success,
  update_tag_preference,
  update_tag_preference_error,
  update_tag_preference_success,
  get_filtered_meals,
  get_filtered_meals_error,
  get_filtered_meals_success,
  bulk_create_meal,
  bulk_create_meal_error,
  bulk_create_meal_success,
  bulk_update_meal,
  bulk_update_meal_error,
  bulk_update_meal_success,
  bulk_create_ingredients,
  bulk_create_ingredients_error,
  bulk_create_ingredients_success
} from './reducer';
import api from '@service/DataService';
import toast from 'react-hot-toast';
import { FileUploadToCloud } from '@app/services/fileUploadService';

function* filterMealsSagas({ payload }) {
  try {
    const req = yield call(api.get, `/meals?page=1&tags=${payload}`);
    const res = req.data;
    const response = res.data;
    yield put({
      type: get_filtered_meals_success.type,
      payload: response
    });
  } catch (error) {
    yield put({
      type: get_filtered_meals_error.type
    });
  }
}

function* getMealsSagas({ payload }) {
  try {
    const {
      page = 1,
      limit = 10,
      type,
      searchString,
      field = 'updated_at',
      sortBy = 'desc',
      shown = null,
      hasTags = null,
      selectedTags
    } = payload;

    let request = ``;

    if (searchString) {
      request = yield call(api.get, `/meals?search=${searchString}`);
    } else {
      request = yield call(api.get, `/meals`, {
        params: {
          page,
          limit,
          sort_by: field || undefined,
          order_by: sortBy || undefined,
          type: type || undefined,
          hidden: shown || undefined,
          no_tags: hasTags !== null ? hasTags : undefined,
          tags: selectedTags?.length ? selectedTags.join(',') : undefined
        }
      });
    }

    const requestRes = request.data;
    const response = requestRes.data;
    yield put({
      type: get_meals_success.type,
      payload: response
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: get_meals_error.type
    });
  }
}

function* getAllMealsSagas({ payload }) {
  try {
    const { page, limit } = payload;
    const request = yield call(
      api.get,
      `/meals?sort_by=created_at&order_by=desc&page=${page}&limit=${limit}`
    );
    const requestRes = request.data;
    const response = requestRes.data;
    yield put({
      type: get_export_success.type,
      payload: response
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: get_export_error.type
    });
  }
}

function* createMealSaga({ payload }) {
  try {
    let data = { ...payload };

    if (payload.images) {
      const responseImage = yield call(FileUploadToCloud, payload.images);
      data.image = responseImage.secure_url;
    }
    delete data['images'];
    const request = yield call(api.post, `/meals`, data);
    const requestRes = request.data;
    const response = requestRes.data;
    toast.success(requestRes.message);
    yield put({
      type: create_meal_success.type,
      payload: response
    });
    setTimeout(() => {
      window.location.href = '/meals';
    }, 1000);
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: create_meal_error.type
    });
  }
}

function* getSingleMeal({ payload }) {
  try {
    const request = yield call(api.get, `/meals/${payload}`);
    const requestRes = request.data;
    const response = requestRes.data;
    yield put({
      type: get_single_meal_success.type,
      payload: response
    });
  } catch (error) {
    console.log(error);
    toast.error(error.response.data || error.message);
    yield put({
      type: get_single_meal_error.type
    });
  }
}

function* DeleteSingleMeal({ payload }) {
  try {
    const request = yield call(api.delete, `/meals/${payload}`);
    const requestRes = request.data;
    const response = requestRes.data;
    console.log(requestRes);
    toast.success(requestRes.message);
    yield put({
      type: delete_meal_success.type,
      payload: response
    });
    setTimeout(() => {
      window.location.href = '/meals';
    }, 1000);
  } catch (error) {
    console.log(error);
    toast.error(error.response.data || error.message);
    yield put({
      type: delete_meal_error.type
    });
  }
}

function* updateMealSaga({ payload }) {
  try {
    const { result, id } = payload;
    let image = ``;
    if (typeof result.images !== 'string') {
      const responseImage = yield call(FileUploadToCloud, result.images);
      image = responseImage.secure_url;
    } else {
      image = result.images;
    }
    const data = {
      ...result,
      image: image
    };
    delete data['images'];
    const request = yield call(api.put, `/meals/${id}`, data);
    const requestRes = request.data;
    const response = requestRes.data;
    toast.success(requestRes.message);
    yield put({
      type: update_meal_success.type,
      payload: response
    });
    setTimeout(() => {
      window.location.href = `/meals/${id}`;
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: update_meal_error.type
    });
  }
}

function* bulkCreateMealSaga({ payload }) {
  const { meals, onClose } = payload;
  try {
    const results = [];

    for (const meal of meals) {
      let image = '';
      if (typeof meal.images !== 'string') {
        const responseImage = yield call(FileUploadToCloud, meal.images);
        image = responseImage.secure_url;
      } else {
        image = meal.images;
      }

      const data = { ...meal, image };
      delete data.images;

      const request = yield call(api.post, `/meals`, data);
      results.push(request.data.data);
    }

    yield put({
      type: bulk_create_meal_success.type,
      payload: results
    });

    toast.success('Meals created successfully');

    if (onClose) onClose();
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({ type: bulk_create_meal_error.type });
  }
}

function* bulkUpdateMealSaga({ payload }) {
  const { payload: mealsPayload, onClose } = payload;
  try {
    const results = [];

    for (const { result, id } of mealsPayload) {
      let image = '';
      if (typeof result.images !== 'string') {
        const responseImage = yield call(FileUploadToCloud, result.images);
        image = responseImage.secure_url;
      } else {
        image = result.images;
      }
      const data = { ...result, image };
      delete data.images;

      const request = yield call(api.put, `/meals/${id}`, data);
      results.push(request.data.data);
    }
    yield put({
      type: bulk_update_meal_success.type,
      payload: results
    });

    toast.success('Meals updated successfully');
    if (onClose) onClose();
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({ type: bulk_update_meal_error.type });
  }
}

function* getWeeklyPreference() {
  try {
    const request = yield call(api.get, `/preferences/weekly`);
    const requestData = request.data;
    const response = requestData.data;
    toast.success(response.message);
    yield put({
      type: get_weekly_preference_success.type
    });
  } catch (error) {
    console.log(error);
    toast.error(error?.response?.data?.message);
    yield put({
      type: get_weekly_preference_error.type
    });
  }
}

function* getWeeklyPreferencePreview() {
  try {
    const request = yield call(api.get, `/preferences/weekly/preview`);
    const requestData = request.data;
    const response = requestData.data;
    yield put({
      type: get_preview_weekly_preference_success.type,
      payload: response
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: get_preview_weekly_preference_error.type
    });
  }
}

function* getTagPreference() {
  try {
    const request = yield call(api.get, `/tagPreferences`);
    const requestData = request.data;
    const response = requestData.data;
    yield put({
      type: get_tag_preferences_success.type,
      payload: response
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: get_tag_preferences_error.type
    });
  }
}

function* getIngredientsList({ payload }) {
  try {
    const { search, page = 1, limit = 10 } = payload;
    let request = ``;
    if (search) {
      request = yield call(api.get, `/ingredients?search=${search}`);
    } else {
      request = yield call(api.get, `/ingredients?page=${page}&limit=${limit}`);
    }
    const requestData = request.data;
    const response = requestData.data;
    yield put({
      type: get_ingredients_success.type,
      payload: response
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: get_ingredients_error.type
    });
  }
}

function* createIngredients({ payload }) {
  try {
    const { data, onClose } = payload;
    let doc = { ...data };

    if (typeof data.image !== 'string' && data.image) {
      const uploadResult = yield call(FileUploadToCloud, data.image);
      if (uploadResult) {
        doc.image = uploadResult.secure_url;
      }
    }

    const request = yield call(api.post, `/ingredients`, doc);
    const requestData = request.data;
    const response = requestData.data;
    yield put({
      type: create_ingredients_success.type,
      payload: response
    });
    onClose();
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: create_ingredients_error.type
    });
  }
}

function* updateIngredient({ payload }) {
  try {
    const { data, onClose, id } = payload;
    let doc = { ...data };

    if (typeof data.image !== 'string' && data.image) {
      const uploadResult = yield call(FileUploadToCloud, data.image);
      if (uploadResult) {
        doc.image = uploadResult.secure_url;
      }
    } else if (data.image) {
      doc.image = data.image;
    }

    const request = yield call(api.patch, `/ingredients/${id}`, doc);
    const requestData = request.data;
    const response = requestData.data;
    toast.success(requestData?.message);
    yield put({
      type: update_ingredient_success.type,
      payload: response
    });
    onClose();
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: update_ingredient_error.type
    });
  }
}

function* getIngredientList({ payload }) {
  try {
    const request = yield call(api.get, `/ingredients/${payload}`);
    const requestData = request.data;
    const response = requestData.data;
    yield put({
      type: get_ingredient_list_success.type,
      payload: response
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: get_ingredient_list_error.type
    });
  }
}

function* deleteIngredient({ payload }) {
  try {
    const request = yield call(api.delete, `/ingredients/${payload}`);
    const request_res = request.data;
    const response = request_res.data;
    toast.success(request_res.message);
    yield put({
      type: delete_ingredient_success.type,
      payload: response
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: delete_ingredient_error.type
    });
  }
}

function* getExportIngredientsList({ payload }) {
  try {
    const { page, limit } = payload;

    const request = yield call(api.get, `/ingredients?page=${page}&limit=${limit}`);
    const requestData = request.data;
    const response = requestData.data;
    yield put({
      type: get_ingredient_export_list_success.type,
      payload: response
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: get_ingredient_export_list_error.type
    });
  }
}

function* updateTagPreference({ payload }) {
  try {
    const request = yield call(api.put, `/tagPreferences`, payload);
    const requestData = request.data;
    const response = requestData.data;
    toast.success(requestData?.message);
    yield put({
      type: update_tag_preference_success.type,
      payload: response
    });
    const closeBtn = document.getElementById('close');
    closeBtn?.click();

    // recalled getWeeklyPreferencePreview
    yield call(getWeeklyPreferencePreview);
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: update_tag_preference_error.type
    });
  }
}

function* bulkCreateIngredientSaga({ payload }) {
  try {
    const results = [];

    for (const data of payload) {
      let image = ``;

      const responseImage = yield call(FileUploadToCloud, data.image);
      image = responseImage.secure_url;

      const doc = { ...data, image };
      if (!doc.image) delete doc.image;
      const req = yield call(api.post, `/ingredients`, doc);
      results.push(req?.data?.data);
    }
    yield put({
      type: bulk_create_ingredients_success.type,
      payload: results
    });
    toast.success(`${results.length} ingredients created successfully`);
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put({
      type: bulk_create_ingredients_error.type
    });
  }
}

function* MealsSagas() {
  yield takeEvery(get_meals.type, getMealsSagas);
  yield takeEvery(get_export.type, getAllMealsSagas);
  yield takeEvery(get_single_meal.type, getSingleMeal);
  yield takeEvery(delete_meal.type, DeleteSingleMeal);
  yield takeEvery(create_meal.type, createMealSaga);
  yield takeEvery(update_meal.type, updateMealSaga);
  yield takeEvery(get_weekly_preference.type, getWeeklyPreference);
  yield takeEvery(get_ingredients.type, getIngredientsList);
  yield takeEvery(create_ingredients.type, createIngredients);
  yield takeEvery(get_ingredient_list.type, getIngredientList);
  yield takeEvery(update_ingredient.type, updateIngredient);
  yield takeEvery(delete_ingredient.type, deleteIngredient);
  yield takeEvery(get_preview_weekly_preference.type, getWeeklyPreferencePreview);
  yield takeEvery(get_ingredient_export_list.type, getExportIngredientsList);
  yield takeEvery(get_tag_preferences.type, getTagPreference);
  yield takeEvery(update_tag_preference.type, updateTagPreference);
  yield takeEvery(get_filtered_meals.type, filterMealsSagas);
  yield takeEvery(bulk_update_meal.type, bulkUpdateMealSaga);
  yield takeEvery(bulk_create_meal.type, bulkCreateMealSaga);
  yield takeEvery(bulk_create_ingredients.type, bulkCreateIngredientSaga);
}

export default MealsSagas;
